export enum SubscriptionScope {
    All = 0,
    Locations = 1,
    Banners = 2,
    Account = 3
}
